import Link from 'next/link';

export const getData = (onClickTypeSkin: () => void) => ({
  questions: [
    {
      title: 'Как присоединиться к Программе привилегий NAOS?',
      answer:
        'Все зарегистрированные в Личном кабинете пользователи автоматически становятся участниками Программы привилегий и получают бонусы за покупки. Если у вас ещё нет Личного кабинета, просто зарегистрируйтесь — это займёт всего пару минут.'
    },
    {
      title: 'В каком случае начисляются баллы?',
      answer: (
        <>
          <p>
            Баллы начисляются за каждую покупку. Если это ваша первая покупка,
            вы получите повышенный кешбэк баллами 15%. Для следующих покупок
            размер кешбэка зависит от уровня в Программе привилегий:
          </p>
          <ul>
            <li>10% на первом уровне</li>
            <li>25% на втором уровне</li>
          </ul>
          <p>
            Размер кешбэка рассчитывается от итоговой суммы заказа после
            применения скидок.
          </p>
          <p>
            <strong>
              При частичной оплате бонусными баллами , новые баллы не
              начисляются.
            </strong>{' '}
            Начисляются баллы сразу после выполнения заказа (когда заказ
            приобретает статус “Выполнен”).
          </p>
        </>
      )
    },
    {
      title: 'В каком случае можно списать баллы?',
      answer: (
        <>
          <p>
            Вы можете оплатить баллами до 50% от суммы заказа, но после их
            списания итоговая стоимость корзины должна быть не менее 1 000 ₽.
            Баллы недоступны к списанию, если применен промокод на скидку.
          </p>
          <p>
            При списании баллов на товар с действующей скидкой расчет итоговой
            суммы осуществляется от изначальной цены - скидка и баллы не
            суммируются.
          </p>
        </>
      )
    },
    {
      title: 'Какие привилегии доступны при первой покупке?',
      answer: (
        <>
          <p>
            Если вы ещё не совершали покупки на сайте или в приложении, вам
            доступна акция: скидка 15% и кешбэк 15% баллами. Промокод на скидку
            придёт на ваш email, поэтому важно согласиться на получение
            рассылок. Промокод не распространяется на новинки, наборы и Age
            Proteom.
          </p>
          <p>
            Если вы уже делали покупки, действует стандартный кешбэк: 10% на
            первом уровне и 25% на втором.
          </p>
        </>
      )
    },
    {
      title: 'Какие преимущества вы можете получить в Программе привилегий?',
      answer: (
        <>
          <p>
            На первом уровне вы получаете 10% кешбэка баллами за каждую покупку.
            Также для вас открыты специальные акции — «секретные распродажи»,
            доступные только участникам Программы привилегий.
          </p>
          <p>
            На втором уровне кешбэк баллами увеличивается до 25% от суммы
            заказа. Дополнительно остаётся доступ к «секретным распродажам».
          </p>
        </>
      )
    },
    {
      title: 'Как перейти на 2 уровень?',
      answer: (
        <>
          <p>
            Чтобы повысить уровень, достаточно совершить покупки на сумму от 5
            000 ₽ в течение 180 дней и заполнить все поля в{' '}
            <button
              onClick={onClickTypeSkin}
              className="link underline underline-offset-4"
            >
              Анкете пользователя
            </button>{' '}
            об особенностях вашей кожи в Личном кабинете.
          </p>
        </>
      )
    },
    {
      title: (
        <>
          Я сделал заказ(ы) на сумму больше 5 000 ₽, но мой уровень не
          повысился. <br />
          Почему?
        </>
      ),
      answer: (
        <>
          <p>Чтобы перейти на 2 уровень, важно выполнить оба условия:</p>
          <ul>
            <li>Сумма ваших заказов за 180 дней должна быть от 5 000 ₽.</li>
            <li>
              В Личном кабинете должны быть заполнены все поля в{' '}
              <button
                onClick={onClickTypeSkin}
                className="link underline underline-offset-4"
              >
                Анкете пользователя
              </button>{' '}
              об особенностях вашей кожи
            </li>
          </ul>
          <p>
            Проверьте, выполнены ли оба условия — это можно сделать в Личном
            кабинете. Если всё верно, но уровень не изменился, попробуйте
            подождать немного: обновление статуса может занять некоторое время.
          </p>
        </>
      )
    },
    {
      title: 'Почему мой уровень изменился?',
      answer: (
        <>
          <p>
            Если ваш уровень повысился с&nbsp;первого
            на&nbsp;второй&nbsp;&mdash; поздравляем! Это значит, что
            за&nbsp;последние 180 дней вы&nbsp;сделали покупки на&nbsp;сумму
            от&nbsp;5&nbsp;000&nbsp;₽ и&nbsp;заполнили все поля в{' '}
            <button
              onClick={onClickTypeSkin}
              className="link underline underline-offset-4"
            >
              Анкете пользователя
            </button>{' '}
            об особенностях вашей кожи. Теперь вам доступен кешбэк 25% баллами и
            другие привилегии.
          </p>
          <p>
            Если же уровень снизился обратно на первый, значит, за 180 дней
            сумма ваших заказов была меньше 5 000 ₽. Но вы всегда можете
            вернуться на 2 уровень, снова набрав нужную сумму покупок.
          </p>
        </>
      )
    },
    {
      title: 'Когда сгорают баллы?',
      answer: (
        <>
          <p>
            Баллы за покупки действуют 365 дней. Также в рамках акций могут
            начисляться бонусные баллы с ограниченным сроком действия — вы
            можете проверить дату их сгорания в Личном кабинете.
          </p>
        </>
      )
    },
    {
      title: 'Где я могу посмотреть все правила Программы привилегий NAOS?',
      answer: (
        <>
          <p>
            Правила Программы привилегий вы можете изучить{' '}
            <Link
              href="/legal/programma-privilegiy-naos/"
              className="link underline underline-offset-4"
            >
              здесь
            </Link>
            .
          </p>
        </>
      )
    }
  ]
});
